import { render, staticRenderFns } from "./AjaxSelect.vue?vue&type=template&id=a4895ea2&"
import script from "./AjaxSelect.vue?vue&type=script&lang=js&"
export * from "./AjaxSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports